module.exports = __webpack_public_path__ + "2bb31fe43576fa1891441eca127ba0e9.MP3";